/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// librariers
import React, { Component } from 'react';
// material
import { SubPage } from '@insticator/insticator-ui'; // iui-material
import EmbedIframe from 'material/embeds/embediframe/embediframe_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/preview/preview_styles';



/* ========== ~~~~~~~~~~ EMBED PREVIEW ~~~~~~~~~~ ========== */
class PreviewPage extends Component {
    componentWillMount() {
        document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
    showPlacement() {
        return this.props.embedLocation === 'in-content' ? 'incontent' : 'rail';
    }
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node.contains(e.target)) { return; }
        this.props.displayModal(false);
    };
    render() {
        return(
            <SubPage name={`preview`} klass={`${this.props.classes.preview} ${this.showPlacement()}`}>
                <div className={`visual`} ref={node => {this.node=node;}}>
                    <div className={`device desktop`}>
                        <div className={`embed-example`}>
                            <EmbedIframe addOn={this.props.addOn} />
                        </div>
                    </div>
                </div>
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PreviewPage);
